import React, {useEffect, useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {useParams} from "react-router";
import {useHistory} from "react-router-dom";
import {Card, Col, Form, Input, InputNumber, Row, Space, Switch, Table} from "antd";
import styles from "../presale-order-detail/index.module.css";
import {PlatformType, PresaleOrderStatusEnum} from "../../utils/constants";
import DatePicker from "../../components/DatePicker";
import AreaSelect from "../../components/AreaSelect";
import DictSelect from "../../components/DictSelect";
import {useForm} from "antd/lib/form/Form";
import {ColumnProps} from "antd/lib/table";
import * as api from '../../apis/returnOrder'
import {useRequest} from "ahooks";


export default function RefundOrderDetail() {

    const [form] = useForm();
    const history = useHistory()
    const {id} = useParams<any>()
    const [returnOrderDetail, setReturnOrderDetail] = useState<any>({})

    useEffect(() => {
        if (id)
            run(id)
    }, [])

    const {run} = useRequest(api.getReturnOrderDetail, {
        manual: true,
        onSuccess: (res) => {
            setReturnOrderDetail(res.data.data)
            form.setFieldsValue(res.data.data)
        }
    })

    const toolbar = (
        <Space className={styles.Toolbar}>
            <a onClick={() => history.goBack()}>返回</a>
        </Space>
    )

    const productColumns: Array<ColumnProps<any>> = [
        {
            dataIndex: 'lineId',
            title: '行号',
        },
        {
            dataIndex: 'productCode',
            key: 'productCode',
            title: '商品编码',
        },
        {
            dataIndex: 'productName',
            key: 'productName',
            title: '商品名称',
        },
        {
            dataIndex: 'specification',
            key: 'specification',
            title: '商品规格',
        },
        {
            dataIndex: 'productCategoryName',
            key: 'productCategoryName',
            title: '产品线',
        },
        {
            dataIndex: 'unit',
            key: 'unit',
            title: '单位',
        },
        {
            dataIndex: 'qty',
            key: 'qty',
            title: '数量',
        },
        {
            dataIndex: 'price',
            key: 'price',
            title: '销售价',
        },
        {
            dataIndex: 'total',
            key: 'total',
            title: '小计'
        }
    ];

    return (
        <PageHeaderLayout>
            <Card title={toolbar}>
                <Form form={form} labelCol={{span: 8}} disabled={true}>
                    <Form.Item name={'id'} noStyle/>
                    <h3 className={styles.SectionTitle}>基本信息</h3>
                    <Row>
                        <Col span={8}>
                            <Form.Item name={'code'}
                                       label={'退货单号'}>
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item name={'orderDate'} label={'订单日期'}>
                                <DatePicker style={{width: '100%'}}/>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item name={'dealerName'} label={'客户'}>
                                <Input/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <div><h3 className={styles.SectionTitle}>商品信息</h3></div>
                    <Form.List name={'item'}>
                        {(fields, operation, meta) => (
                            <Table className={styles.ProductTable} columns={productColumns}
                                   dataSource={form.getFieldValue('item')} pagination={false} scroll={{x: '100%'}}/>
                        )}
                    </Form.List>
                </Form>
            </Card>
        </PageHeaderLayout>
    )
}